module.exports = __webpack_public_path__ + "img/usa-stomach-cancer-female.7e4ecde2.png";